import React, { useState } from "react";
import {
  Avatar,
  Card,
  CardHeader,
  Grid,
  Typography,
  CardContent,
  Divider,
  ButtonBase,
  IconButton,
  CardActions,
  Tooltip,
  Button,
} from "@material-ui/core";
import MoreHorizIcon from "@material-ui/icons/MoreHoriz";
import MessageIcon from "@material-ui/icons/Message";
import DateRangeIcon from "@material-ui/icons/DateRange";
import Styles from "../../../Styles.module.css";
import Rating from "@material-ui/lab/Rating";
import { useHistory } from "react-router";
import { useRouteMatch } from "react-router-dom";
import clsx from "clsx";
import { useNavigateToMessage } from "souqh-react-redux-hooks/common/useNavigateToMessage";
import * as moment from "moment";
import MoreOptionsOnClientInfo from "./MoreOptionsOnClientInfo";
import {
  isMobileDevice,
  isProPlan,
  viewClientDetails,
} from "../../../utils/AppUtils";
import { useAuthUser } from "souqh-react-redux-hooks/useLogin";
import UpgradePlanIconSection from "../../common/UpgradePlanIconSection";

export default function CompletedClientInfoCard({ data }) {
  const [anchorEl, setAnchorEl] = useState(null);
  const [showMoreInfo, setShowMoreInfo] = useState(false);

  const handleClick = (event) => {
    event.stopPropagation();
    setAnchorEl(event.currentTarget);
  };
  const history = useHistory();
  let { path } = useRouteMatch();
  const userInfo = useAuthUser();
  const { navigateMessage } = useNavigateToMessage();
  const review =
    data.hbServiceReviews &&
    data.hbServiceReviews.length &&
    data.hbServiceReviews.filter(
      (ele) => data.serviceRequestId === ele.serviceRequestId
    )[0];

  const showMoreInfoCondition = isMobileDevice() && showMoreInfo;

  return (
    <Card
      elevation={0}
      style={{ border: !isMobileDevice() && "1px solid #0000001F" }}
    >
      <MoreOptionsOnClientInfo
        anchorEl={anchorEl}
        setAnchorEl={setAnchorEl}
        showLiveMeetingOption={true}
        toUserId={data.hbDetails.userId}
        serviceRequestId={data.serviceRequestId}
        isCompletedTab={true}
      />
      <CardHeader
        style={{
          cursor: "pointer",
          padding: isMobileDevice() && "16px 8px 16px 0px",
        }}
        onClick={() => {
          viewClientDetails(history, path, data);
        }}
        avatar={
          <Avatar
            style={{ height: 76, width: 76, borderRadius: 4 }}
            variant="square"
            src={data.avatarUrl}
          >
            {(data.name || "").charAt(0)}
          </Avatar>
        }
        action={
          <ButtonBase>
            <MoreHorizIcon
              className={Styles.navyBlueColor}
              onClick={handleClick}
            />
          </ButtonBase>
        }
        title={
          <Typography
            className={Styles.navyBlueColor}
            variant="body1"
            style={{ fontWeight: 500, marginLeft: 10 }}
          >
            {data.name}
          </Typography>
        }
        subheader={
          <>
            <Grid container>
              <Grid item xs={3}>
                <IconButton>
                  <MessageIcon
                    className={Styles.navyBlueColor}
                    onClick={(event) => {
                      navigateMessage(event, data.email);
                    }}
                  />
                </IconButton>
              </Grid>
              <Grid item xs={3}>
                {/* <IconButton> */}
                <div style={{ position: "relative", top: 9 }}>
                  <DateRangeIcon
                    style={{
                      color: isProPlan(userInfo) && "grey",
                      cursor: isProPlan(userInfo) ? "default" : "pointer",
                    }}
                    className={Styles.navyBlueColor}
                    onClick={(event) => {
                      event.stopPropagation();
                      if (!isProPlan(userInfo)) {
                        history.push(
                          "/app/serviceprovider/calendar?scheduleMeeting=true"
                        );
                      }
                    }}
                  />
                  {isProPlan(userInfo) && (
                    <UpgradePlanIconSection
                      iconBtnStyle={{
                        position: "absolute",
                        fontSize: 16,
                        left: 12,
                        top: -10,
                        fill: "#fa7e61",
                      }}
                      iconStyle={{
                        position: "absolute",
                        fontSize: 16,
                        top: 5,
                        fill: "#fa7e61",
                      }}
                    />
                  )}
                </div>
                {/* </IconButton> */}
              </Grid>
            </Grid>
          </>
        }
      />
      {(!isMobileDevice() || showMoreInfoCondition) && (
        <React.Fragment>
          <Divider />
          <CardContent>
            <Grid container>
              <Grid item xs={6}>
                <Grid item>
                  <Typography
                    className={Styles.navyBlueColor}
                    variant="body1"
                    style={{ fontWeight: 500 }}
                  >
                    Request Date
                  </Typography>
                </Grid>
                <Grid item>
                  <Typography
                    className={clsx(Styles.navyBlueColor, Styles.font14)}
                  >
                    {moment(data.requestedDate).format("MMM DD, YYYY")}
                  </Typography>
                </Grid>
              </Grid>
              <Grid item xs={6}>
                <Grid item>
                  <Typography
                    className={Styles.navyBlueColor}
                    variant="body1"
                    style={{ fontWeight: 500 }}
                  >
                    Complete Date
                  </Typography>
                </Grid>
                <Grid item>
                  <Typography
                    className={clsx(Styles.navyBlueColor, Styles.font14)}
                  >
                    {moment(data.completeDate).format("MMM DD, YYYY")}
                  </Typography>
                </Grid>
              </Grid>
            </Grid>
            <Divider style={{ margin: "15px 0px" }} />
            <Grid item>
              <Typography
                className={Styles.navyBlueColor}
                variant="body1"
                style={{ fontWeight: 500 }}
              >
                Review
              </Typography>
            </Grid>
            {review ? (
              <Grid item container xs={12}>
                <Grid item xs={3}>
                  <Rating
                    name="rating"
                    value={review.starRating}
                    className={Styles.navyBlueColorForce}
                    style={{ fontSize: 16 }}
                    readOnly
                  />
                </Grid>
                <Grid item xs={9} style={{ paddingLeft: 10 }} container>
                  <Typography
                    className={clsx(Styles.navyBlueColor, Styles.font14)}
                  >
                    {review.serviceName}
                  </Typography>
                </Grid>

                <Grid item xs={12}>
                  <Tooltip title={review.reviewComments}>
                    <Typography
                      className={clsx(
                        Styles.navyBlueColor,
                        Styles.font14,
                        Styles.sqEllipsisTwoLines
                      )}
                    >
                      {review.reviewComments}
                    </Typography>
                  </Tooltip>
                </Grid>
              </Grid>
            ) : (
              <Grid item xs={12}>
                <Typography
                  className={clsx(Styles.navyBlueColor, Styles.font14)}
                  style={{ minHeight: "3em" }}
                >
                  No details available
                </Typography>
              </Grid>
            )}
          </CardContent>
        </React.Fragment>
      )}
      {!isMobileDevice() && (
        <React.Fragment>
          <Divider style={{ margin: "15px 0px 5px 0px" }} />
          <CardActions disableSpacing>
            <Grid container item xs={12} justifyContent="flex-end">
              <ButtonBase
                onClick={() => {
                  history.push(`${path}/reviews`);
                }}
              >
                <Typography
                  style={{ paddingRight: 10 }}
                  className={clsx(Styles.navyBlueColor, Styles.font14)}
                >
                  View Details
                </Typography>
              </ButtonBase>
            </Grid>
          </CardActions>
        </React.Fragment>
      )}
      {isMobileDevice() && (
        <Grid container item xs={12} justifyContent="flex-end">
          <Button
            variant="text"
            className={Styles.primaryTxtAccentForce}
            style={{
              textTransform: "capitalize",
              marginTop: -28,
            }}
            onClick={(event) => {
              event.stopPropagation();
              setShowMoreInfo(!showMoreInfo);
            }}
          >
            {showMoreInfo ? "Show less" : "Show more"}
          </Button>
        </Grid>
      )}
    </Card>
  );
}
